<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Navn:</th>
          <th>Salgsstatus:</th>
          <th>Pris:</th>
          <th>BRA:</th>
          <th>Soverom:</th>
        </tr>
      </thead>
      <tr
        v-for="residence in residences"
        :key="residence.id"
      >
        <td>{{ residence.name }}</td>
        <td>{{ residence.availability.name }}</td>
        <td>{{ residence.price }},-</td>
        <td>{{ residence.size }}m²</td>
        <td>{{ residence.bedrooms.name }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Residence from '@/models/Residence';

export default {
  name: 'Comparison',
  computed: {
    residences() {
      return Residence
        .query()
        .withAll()
        .get();
    },
  },
};

</script>

<style lang="scss" scoped>

table {
  display: flex;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 1em;
  scrollbar-color: transparent;
  position: relative;
}

thead {
  position: sticky;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  background: #eee;
}

tr {
  display: flex;
  flex-direction: column;
}

td {
  min-width: 200px;
}
</style>